import React, { useState } from 'react';
import type { V2Pharmacy } from '../../types/api-v2.types';
import Modal from '../atoms/modal';
import Text from '../text';
import { fetchPreferredPharmacyInfo } from '../../store/modules/pharmacy-module';
import { Color } from '../../styles/colors';
import type { Dispatch } from '../../types/app.types';

export const MODAL_NAME = 'preferred-pharmacy';

const PharmacyValueProp = ({ data }) => {
  const Icon = {
    'contactless purchase': require('../../assets/illustrations/pre-pay-circle.svg'),
    'less wait time': require('../../assets/illustrations/time-circle.svg'),
    'personalized care': require('../../assets/illustrations/cx-help-circle.svg'),
  };
  return (
    <div className="d-sm-flex flex-sm-column align-items-sm-center my-sm-48">
      <img src={Icon[data.name.toLowerCase()]} alt={data.name} />
      <Text
        color={Color.white100}
        type="title4-blinkui"
        style={{
          margin: '12px 0 0',
          fontSize: '16px',
          fontWeight: 500,
          lineHeight: 1.5,
        }}
      >
        {data.name}
      </Text>
      <Text
        color={Color.white100}
        type="body3-blinkui"
        style={{
          margin: '4px 0 0',
          fontSize: '14px',
          fontWeight: 300,
          lineHeight: 1.43,
        }}
      >
        {data.description}
      </Text>
    </div>
  );
};

const PreferredPharmacyModal = ({ dispatch, pharmacy }: { dispatch: Dispatch; pharmacy: V2Pharmacy }) => {
  const pharmacyId = (pharmacy.location && pharmacy.location.id) || '';
  const [info, setInfo]: any = useState();

  const fetchInfo = () => {
    dispatch(fetchPreferredPharmacyInfo(pharmacyId)).then((res) => setInfo(res));
  };

  return (
    <Modal name={MODAL_NAME} title="Preferred Pharmacy" onOpen={fetchInfo} fullBleed dismissible>
      <div className="d-sm-flex flex-sm-column">
        <Text type="body2-blinkui" className="px-sm-20">
          Preferred pharmacies partner closely with Blink to deliver unique benefits to all their patients.
        </Text>
        <div
          className="px-sm-36 mt-sm-12"
          style={{
            backgroundColor: Color.secondary100,
            overflow: 'auto',
          }}
        >
          {info && info.pharmacyValueProps.map((item, i) => <PharmacyValueProp key={`value-${i}`} data={item} />)}
        </div>
      </div>
    </Modal>
  );
};

export default PreferredPharmacyModal;
